module.exports = __webpack_public_path__ + "static/media/MovingApp_android_2.72aa3d81.jpg";